export function OutlineStopIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0032 3H4.9968C3.894 3 3 3.894 3 4.9968V19.0032C3 20.106 3.894 21 4.9968 21H19.0032C20.106 21 21 20.106 21 19.0032V4.9968C21 3.894 20.106 3 19.0032 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
